import cx from 'classnames';
import { Icon } from '@components/icon/Icon';
import typography from '~styles/typography.scss';
import { DEFAULT_NO_RECORDED_GUEST_NOTE_TEXT } from '../../../utils/constants';
import styles from './GuestNotesShow.scss';

export interface GuestNotesShowFormProps {
  note: string;
  onEdit: () => void;
  updatedBy?: string | null;
  className?: string;
}

export const GuestNotesShow = ({
  onEdit,
  note,
  updatedBy,
  className,
}: GuestNotesShowFormProps) => (
  <section
    aria-labelledby="guest-notes-heading"
    className={cx(styles.showForm, className)}
  >
    <header>
      <h3 id="guest-notes-heading" className={typography.h7}>
        <Icon name="user" /> Guest Notes
      </h3>
      <button onClick={onEdit}>
        <Icon name="pencil" />
        <span className={typography.t3}>Edit</span>
      </button>
    </header>
    <p className={typography.t1}>
      {note || DEFAULT_NO_RECORDED_GUEST_NOTE_TEXT}
    </p>
    {updatedBy && (
      <div className={cx(styles.updatedBy, typography.t2)}>
        Last updated by: {updatedBy}
      </div>
    )}
  </section>
);
